import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface InlineNoticeProps {
  children: ReactNode;
  icon?: ReactNode;
  tone?: "success" | "danger" | "muted";
  className?: string;
}

const toneClasses: Record<NonNullable<InlineNoticeProps["tone"]>, string> = {
  success: "border-emerald-500/40 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400",
  danger: "border-destructive/40 bg-destructive/10 text-destructive",
  muted: "border-border bg-muted/30 text-muted-foreground",
};

export function InlineNotice({ children, icon, tone = "muted", className }: InlineNoticeProps) {
  return (
    <div
      className={cn(
        "flex items-start gap-3 rounded-md border px-4 py-3 text-sm",
        toneClasses[tone],
        className,
      )}
    >
      {icon ? <div className="mt-0.5 shrink-0">{icon}</div> : null}
      <div>{children}</div>
    </div>
  );
}
